import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  getFormPdf,
  clearDefaultForm
} from 'actions';

import Button from 'components/Common/Buttons';
import CustomerAvatar from 'components/CustomerAvatar';

class SuccessPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        formType: PropTypes.string,
        formId: PropTypes.string
      }),
      url: PropTypes.string
    }).isRequired,
    history: PropTypes.shape({
      action: PropTypes.string,
      listen: PropTypes.func,
      replace: PropTypes.func,
      go: PropTypes.func,
      location: PropTypes.shape({
        pathname: PropTypes.string
      })
    }).isRequired,
    formTypes: PropTypes.arrayOf(PropTypes.shape({})),
    isFetchingPdfForm: PropTypes.bool,
    // eslint-disable-next-line react/no-unused-prop-types
    pdfData: PropTypes.string,
    previewOnlyMode: PropTypes.bool,
    defaultFormType: PropTypes.string,
  };

  static defaultProps = {
    formTypes: [],
    pdfData: null,
    isFetchingPdfForm: false,
    previewOnlyMode: false,
    defaultFormType: null
  };

  constructor(props) {
    super(props);

    const { dispatch, defaultFormType } = props;

    this.state = {
      pdfDownload: null
    };

    this.onResize = this.onResize.bind(this);

    if (defaultFormType) {
      dispatch(clearDefaultForm());
    }
  }

  componentDidMount() {
    const { history } = this.props;
    window.addEventListener('popstate', this.onResize);

    this.eventHandler = history.listen((location) => {
      // console.log(location.pathname);
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.isFetchingPdfForm && props.pdfData && (!state.pdfDownload || props.pdfData !== state.pdfDownload)) {
      return {
        pdfDownload: props.pdfData
      };
    }
    return {
      pdfDownload: null
    };
  }

  componentDidUpdate(prevProps) {
    const {
      match: { params: { formType } },
      isFetchingPdfForm,
      pdfData
    } = this.props;

    if (prevProps.isFetchingPdfForm && !isFetchingPdfForm && pdfData) {
      const link = document.createElement('a');
      link.href = pdfData;
      link.setAttribute('download', `${ formType }.pdf`);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    }
  }

  componentWillUnmount() {
    const { pdfDownload } = this.state;

    if (pdfDownload) {
      URL.revokeObjectURL(pdfDownload);
    }

    window.removeEventListener('popstate', this.onResize);
    this.eventHandler();
  }

  // eslint-disable-next-line
  onResize() {
    // console.log('popped');
  }

  getFormTypeMarkup() {
    const { match: { params: { formType } }, formTypes } = this.props;
    let form = 'form';
    let version = 'revision';

    if (formTypes) {
      const formTypeDetails = formTypes.filter(ft => ft.formType === formType);

      if (formTypeDetails && formTypeDetails[0]) {
        const { title, revision } = formTypeDetails[0];
        form = title;
        version = revision;
      }
    }

    return (
      <div className="mv-2">
        <h1>{ form }</h1>
        { version && <h4>Rev. { version }</h4> }
      </div>
    );
  }

  cancelBackNavigation = () => {
    const { history } = this.props;
    history.go(1);
  }

  // eslint-disable-next-line class-methods-use-this
  routerWillLeave(nextState) {
    if (nextState.action === 'POP') {
      return false;
    }
    return true;
  }

  downloadPdf() {
    const { dispatch, match: { params: { formId } } } = this.props;

    dispatch(getFormPdf(formId));
  }

  render() {
    const { isFetchingPdfForm, previewOnlyMode } = this.props;
    return (
      <section className="success-page">
        <div className="row">
          <div className="col-12">
            <CustomerAvatar className="mobile-username" />
          </div>
        </div>
        <div className="row">
          <div className="col-12 offset-sm-2 col-sm-8 offset-md-3 col-md-6 offset-lg-4 col-lg-4 content">
            <h1>Success</h1>
            <span className="check-icon">
              <FontAwesomeIcon icon="check-circle" size="4x" />
            </span>
            <h3><FormattedMessage id={ previewOnlyMode ? 'successPage.previewOnlyMode.intro' : 'successPage.intro' } /></h3>
            { this.getFormTypeMarkup() }
            <p><FormattedMessage id="successPage.disclaimer" /></p>
            <p><FormattedMessage id="successPage.formSelectionText" /></p>
            <p><FormattedMessage id="successPage.downloadPDFInstruction" /></p>
            <div className="row mt-4">
              <div className="col-12 mb-4">
                <Button
                  className={ `btn-secondary btn-download mr-0 ${ isFetchingPdfForm ? 'btn-active' : '' }` }
                  value="Download PDF"
                  onClick={ () => this.downloadPdf() }
                />
              </div>
              <div className="col-12 link">
                <Link to="/form-selection" className="btn btn-link"> <FormattedMessage id="successPage.formSelectionLink" /></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig
    },
    form: {
      pdfData,
      isFetchingPdfForm
    }
  } = state;

  return {
    formTypes: onlineConfig && onlineConfig.formTypes,
    previewOnlyMode: onlineConfig && onlineConfig.previewOnlyMode,
    pdfData,
    isFetchingPdfForm,
    customerName: onlineConfig && onlineConfig.customerName,
    defaultFormType: onlineConfig ? onlineConfig.defaultFormType : null,
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SuccessPage));
